import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Input } from 'antd';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { searchAndAddArticulo } from '../../../../state/actions/creators/encargos.creador.actioncreator';
import { Box, Flex, Text } from '../../../shared/components';


class AgregadorDeArticulos extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      textoBusqueda: '',
    };
  }

  render() {
    const {
      searchAndAddArticulo, encargoUUID, intl, cargando, onSeleccionarArticulos,
    } = this.props;
    const { textoBusqueda } = this.state;

    return (
        <Flex alignItems="baseline" mt="16px">
          <Input
            size="large"
            value={textoBusqueda}
            onChange={e => this.setState({ textoBusqueda: e.target.value })}
            disabled={cargando}
            onPressEnter={(e) => {
              searchAndAddArticulo({ codigo: e.target.value, encargoUUID });
              this.setState({ textoBusqueda: '' });
            }}
            placeholder={intl.formatMessage({ id: 'encargos.introducir_codigo' })}
            style={{ minWidth: '138px', marginRight: '8px' }}
          />
          <Button size="large" type="primary" onClick={()=>onSeleccionarArticulos()}><Text translationId="encargos.buscar_articulo" /></Button>
        </Flex>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchAndAddArticulo,
  }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(AgregadorDeArticulos));

AgregadorDeArticulos.propTypes = {
  encargoUUID: PropTypes.string.isRequired,
  onSeleccionarArticulos: PropTypes.func.isRequired,
  estadoPeticionBuscarArticulo: PropTypes.shape({
    running: PropTypes.bool,
  }),
  searchAndAddArticulo: PropTypes.func.isRequired,
  cargando: PropTypes.bool,
};

AgregadorDeArticulos.defaultProps = {
  estadoPeticionBuscarArticulo: {
    running: false,
  },
  cargando: false,
};
